var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 42 42",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_604_31635)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.85719 5.90625H40.0312C41.1185 5.90625 41.9999 6.78768 41.9999 7.875V34.2365C41.9999 35.2621 41.1684 36.0937 40.1427 36.0937H1.85719C0.831551 36.0937 0 35.2622 0 34.2365V7.76336C0 6.73772 0.831551 5.90625 1.85719 5.90625Z",
      "fill": "#FFCB5B"
    }
  }), _c('path', {
    attrs: {
      "d": "M41.3437 8.90539L22.9688 19.2544C21.7706 19.9279 20.3081 19.9279 19.11 19.2544L0.656261 8.90539C0.248565 8.67005 -0.00187613 8.2343 1.05856e-05 7.76352C1.05856e-05 6.7378 0.831479 5.90625 1.8572 5.90625H40.1428C41.1685 5.90625 42 6.73772 42 7.76344C42.0018 8.23422 41.7515 8.66996 41.3437 8.90539Z",
      "fill": "#FFDB6F"
    }
  }), _c('path', {
    attrs: {
      "d": "M41.9999 7.80859C41.9857 8.26288 41.7374 8.67747 41.3437 8.90453L22.9688 19.2535C21.7706 19.927 20.3081 19.927 19.11 19.2535L0.656253 8.90453C0.262503 8.67747 0.014194 8.26288 2.60898e-06 7.80859V7.87422V9.18672C-0.000899735 9.64019 0.232315 10.062 0.616878 10.3023L18.913 21.7342C20.1757 22.455 20.9677 23.7852 20.9999 25.2386V29.4845C20.9999 31.6845 19.2165 33.468 17.0165 33.468H5.90633C4.45651 33.468 3.28133 34.6432 3.28133 36.093H40.1428C41.1685 36.093 42 35.2615 42 34.2358V7.87422C41.9999 7.87422 41.9999 7.83484 41.9999 7.80859Z",
      "fill": "#F7B84E"
    }
  }), _c('path', {
    attrs: {
      "d": "M22.9295 19.2603C21.7314 19.9338 20.2689 19.9338 19.0708 19.2603L0.695801 8.9375C0.763641 9.00165 0.836074 9.06088 0.912363 9.11469L18.9067 20.2709C20.1788 21.0608 21.7887 21.0608 23.0607 20.2709L41.0551 9.11469C41.1314 9.06088 41.2037 9.00165 41.2717 8.9375L22.9295 19.2603Z",
      "fill": "#F19920"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.3841 14.5229L12.2129 11.6484C11.5785 11.2977 11.3487 10.4991 11.6994 9.86475C11.9342 9.44016 12.384 9.17971 12.8691 9.1875H13.125C13.4875 9.1875 13.7813 8.89367 13.7813 8.53125C13.7813 8.16884 13.4875 7.875 13.125 7.875H5.25012C5.01477 7.8741 4.7969 7.99928 4.67918 8.20313C4.50339 8.5201 4.61774 8.91951 4.93463 9.09538C4.93479 9.09547 4.93496 9.09555 4.93512 9.09563L16.7476 15.6581C17.0383 15.8746 17.4495 15.8144 17.6659 15.5237C17.8824 15.233 17.8221 14.8218 17.5314 14.6054C17.486 14.5716 17.4365 14.5439 17.3841 14.5229Z",
      "fill": "#FFE278"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.75 7.875H19.6875C20.0499 7.875 20.3438 8.16884 20.3438 8.53125C20.3438 8.89366 20.0499 9.1875 19.6875 9.1875H15.75C15.3876 9.1875 15.0938 8.89366 15.0938 8.53125C15.0938 8.16875 15.3876 7.875 15.75 7.875Z",
      "fill": "#FFE278"
    }
  }), _c('path', {
    attrs: {
      "d": "M32.8125 24.2812C30.6379 24.2812 28.875 26.0441 28.875 28.2188C28.875 30.3933 30.6379 32.1562 32.8125 32.1562C34.9871 32.1562 36.75 30.3934 36.75 28.2188C36.75 26.0442 34.9871 24.2812 32.8125 24.2812ZM32.8125 30.8438C31.3627 30.8438 30.1875 29.6686 30.1875 28.2188C30.1875 26.7691 31.3628 25.5938 32.8125 25.5938C34.2622 25.5938 35.4375 26.7691 35.4375 28.2188C35.4375 29.6686 34.2622 30.8438 32.8125 30.8438Z",
      "fill": "#B06328"
    }
  }), _c('path', {
    attrs: {
      "d": "M26.4927 30.3253C25.5662 31.009 24.3022 31.009 23.3756 30.3253C21.969 29.2588 20.0245 29.2588 18.6178 30.3253C18.3422 30.5606 18.3095 30.9749 18.5449 31.2504C18.7699 31.514 19.1611 31.5571 19.4381 31.3489C20.3647 30.6652 21.6287 30.6652 22.5552 31.3489C23.9619 32.4154 25.9064 32.4154 27.313 31.3489C27.5887 31.1136 27.6213 30.6993 27.386 30.4238C27.161 30.1602 26.7698 30.1171 26.4927 30.3253Z",
      "fill": "#B06328"
    }
  }), _c('path', {
    attrs: {
      "d": "M26.4927 27.7003C25.5662 28.384 24.3022 28.384 23.3756 27.7003C21.969 26.6338 20.0245 26.6338 18.6178 27.7003C18.3422 27.9356 18.3095 28.3499 18.5449 28.6254C18.7699 28.889 19.1611 28.9321 19.4381 28.7239C20.3647 28.0402 21.6287 28.0402 22.5552 28.7239C23.9619 29.7904 25.9064 29.7904 27.313 28.7239C27.6028 28.5063 27.6613 28.0948 27.4436 27.8051C27.2259 27.5154 26.8145 27.4569 26.5247 27.6746C26.5137 27.6829 26.5031 27.6914 26.4927 27.7003Z",
      "fill": "#B06328"
    }
  }), _c('path', {
    attrs: {
      "d": "M26.4927 25.0753C25.5662 25.759 24.3022 25.759 23.3756 25.0753C21.969 24.0088 20.0245 24.0088 18.6178 25.0753C18.3422 25.3106 18.3095 25.7249 18.5449 26.0004C18.7699 26.264 19.1611 26.3071 19.4381 26.0989C20.3647 25.4152 21.6287 25.4152 22.5552 26.0989C23.9619 27.1654 25.9064 27.1654 27.313 26.0989C27.6028 25.8813 27.6613 25.4698 27.4436 25.1801C27.2259 24.8904 26.8145 24.8319 26.5247 25.0496C26.5137 25.0579 26.5031 25.0665 26.4927 25.0753Z",
      "fill": "#B06328"
    }
  }), _c('path', {
    attrs: {
      "d": "M32.812 29.5254C33.5369 29.5254 34.1245 28.9378 34.1245 28.2129C34.1245 27.488 33.5369 26.9004 32.812 26.9004C32.0871 26.9004 31.4995 27.488 31.4995 28.2129C31.4995 28.9378 32.0871 29.5254 32.812 29.5254Z",
      "fill": "#B06328"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_604_31635"
    }
  }, [_c('rect', {
    attrs: {
      "width": "42",
      "height": "42",
      "fill": "white"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }